import { NavLinkProps } from 'react-router-dom';
import { PACK } from '../../../../submodules/web-shared/consts/packs';
import { getCurrentPack } from '../../../../submodules/web-shared/utils';

export const getExternalLinkHref = (
  pack: PACK,
  to: NavLinkProps['to'],
  memorizedCurrentLocation: string = ''
) => {

  const buildHref = (pathname?: string, search?: string) => {
    if (!pathname) return `/${pack}`;
    const path = buildPathname(pathname);
    const query = search ? `?${search}` : '';
    return `/${pack}${path}${query}`;
  };

  if (typeof to === 'string') {
    // Extract pathname and search from the string 'to' and combine with memorized current location for query parameters
    const querySeparatorIndex = to.indexOf('?');
    const pathname = querySeparatorIndex === -1 ? to : to.slice(0, querySeparatorIndex);
    const search = querySeparatorIndex === -1 ? '' : to.slice(querySeparatorIndex + 1);
    const combinedSearch = search && memorizedCurrentLocation
      ? `${search}&${memorizedCurrentLocation}`
      : search || memorizedCurrentLocation;

    return buildHref(pathname, combinedSearch);
  }

  const getSearch = () => {
    if (to.search && memorizedCurrentLocation) {
      return `${to.search}&${memorizedCurrentLocation}`;
    }
    if (!to.search && memorizedCurrentLocation) {
      return memorizedCurrentLocation;
    }
    return to.search;
  };

  return buildHref(to.pathname, getSearch());
};

export const getInternalLink = (
  to: NavLinkProps['to'],
) => {

  if (typeof to === 'string') {
    return buildPathname(to);
  }

  return {
    ...to,
    pathname: to.pathname && buildPathname(to.pathname),
  };

};

export const buildPathname = (pathname: string) => {
  if (pathname.startsWith('/') || pathname.startsWith('.')) return pathname;
  return `/${pathname}`;
};

export const isInternalLink = (pack: string) => {
  const currentPack = getCurrentPack();
  return pack === currentPack;
};